import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La oksigeno estas necesa por la vivo; sed ankaŭ sen oro ne facilas vivi. Kio ja okazas en realo?
    </p>
    
    <p class="mb-3">
      Kiam oni spiras facile, kaj pri la oksigeno, ŝajne, ĉio bonordas – oni tamen sentas, ke da oro ne sufiĉas. Kiam alvenas oro – la spirado plimalfaciliĝas, kaj tio signifas, ke mankas oksigeno.
    </p>
    
    <p class="mb-3">
      Ja la leĝoj de kemio, la plej antikvaj leĝoj de la Tero, asertas, ke la oro kaj la oksigeno nekunigeblas.
    </p>
    `
  )
}

const itemName = {
  esp: 'La oro'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;